import React from 'react';
import styled from '@emotion/styled/macro';
import GroupedTableHead from './grouped-table-head';
import GroupedTableRow from './grouped-table-row';
import GroupedTableCell from './grouped-table-cell';
import vars from '../../variables';

const GroupedTable = ({
  tableHeadData,
  tableData,
  children,
  firstRowLabel,
  isVisible = true,
  className,
}) => {
  if (isVisible) {
    return (
      <table className={className} data-testid="grouped-table">
        <GroupedTableHead tableHeadData={tableHeadData} />
        {Array.isArray(tableData) || children ? (
          <tbody>
            {Array.isArray(tableData) &&
              generateTableContents(tableData, firstRowLabel)}
            {children ? children : null}
          </tbody>
        ) : null}
      </table>
    );
  } else {
    return null;
  }
};

const generateTableContents = (tableData, firstRowLabel) => {
  return tableData.map((item, index) => {
    const isPercentage = item.percentage ? true : false;
    return (
      <GroupedTableRow key={`${item.category}-${index}`}>
        {index === 0 ? (
          <GroupedTableCell content={firstRowLabel} />
        ) : (
          <GroupedTableCell content="" isFirstCellEmpty={true} />
        )}
        <GroupedTableCell content={item.category} />
        <GroupedTableCell
          content={item.percentage}
          isPercentage={isPercentage}
        />
      </GroupedTableRow>
    );
  });
};

const StyledGroupedTable = styled(GroupedTable)`
  width: 100%;
  padding: 0;
  margin: ${vars.spacingXs} 0 0 0;
  border-spacing: 0;
  border-collapse: collapse;
  :first-of-type {
    margin: ${vars.spacingS} 0 0 0;
  }
  th {
    border: none;
    padding: 0;
    background-color: transparent;
  }
  :first-of-type ${GroupedTableHead} {
    th {
      border: 1px solid ${vars.borderGrey};
      padding: ${vars.spacingXs};
      ${vars.fontSize1}
      color: ${vars.black};
      text-align: right;
      vertical-align: top;
      font-weight: ${vars.fontWeightBold};
      border: 1px solid ${vars.borderMidGrey};
      background-color: ${vars.borderGrey};
      text-align: left;
    }
    th:last-of-type {
      text-align: right;
    }
  }
  ${GroupedTableCell} {
    border: 1px solid ${vars.borderGrey};
    padding: ${vars.spacingXs};
    ${vars.fontSize2}
    color: ${vars.black};
    text-align: left;
    vertical-align: top;
  }
  ${GroupedTableCell}:last-of-type {
    text-align: right;
  }
  ${GroupedTableCell}:first-of-type {
    ${vars.fontSize1}
    background-color: transparent;
    border-left-color: transparent;
    border-top-color: transparent;
    border-bottom-color: transparent;
  }
  ${GroupedTableRow}:first-of-type {
    ${GroupedTableCell}:first-of-type {
      font-weight: ${vars.fontWeightBold};
      border: 1px solid ${vars.borderGrey};
      background-color: ${vars.greyHavens};
    }
  }
`;

export default StyledGroupedTable;
